export const adjustTopValue = (container, newValue = 0) => {
  if (container && container.style) {
    container.style.top = `${newValue}px`;
  }
};
